// ABOUTME: Hook that resolves the configurator display currency: the cpq.currency system
// ABOUTME: setting wins, otherwise it falls back to the browser-locale-derived currency.

import { getBrowserCurrency } from '@src/_new/utils/browserCurrency';
import { SettingsContext } from '@src/modules/setting/SettingsContext';
import { useContext } from 'react';

// Reads settings.cpq directly (not via useCpqSettings) so the currency setting applies even
// when the CPQ module is disabled, e.g. in the prototype configurator preview.
export function useConfiguratorCurrency(): string {
    const settings = useContext(SettingsContext);
    return settings.cpq?.currency ?? getBrowserCurrency();
}
